import React from 'react';

function IconHeart() {
  return (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8791 8.88915L9.0077 15.5L2.13626 8.88915M2.13626 8.88915C1.68302 8.46072 1.32601 7.94577 1.08772 7.37673C0.849422 6.80769 0.734997 6.19689 0.75165 5.58278C0.768302 4.96867 0.915671 4.36456 1.18448 3.8085C1.45328 3.25243 1.8377 2.75645 2.31353 2.3518C2.78935 1.94714 3.34628 1.64257 3.94923 1.45727C4.55218 1.27197 5.1881 1.20994 5.81694 1.27511C6.44578 1.34027 7.05392 1.53121 7.60306 1.83589C8.1522 2.14058 8.63045 2.55242 9.0077 3.04547C9.38657 2.556 9.86538 2.14776 10.4141 1.8463C10.9629 1.54485 11.5698 1.35667 12.1969 1.29354C12.824 1.23042 13.4577 1.2937 14.0585 1.47944C14.6592 1.66517 15.214 1.96936 15.6882 2.37296C16.1623 2.77657 16.5456 3.27089 16.814 3.82501C17.0825 4.37912 17.2303 4.9811 17.2482 5.59326C17.2661 6.20541 17.1538 6.81458 16.9182 7.38262C16.6826 7.95066 16.3289 8.46536 15.8791 8.89449"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export default IconHeart;
